import React, { useState, useEffect } from 'react';

const MobileOnlyFooter = () => {
    const [visible, setVisible] = useState(true);
    const [lastScrollTop, setLastScrollTop] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const st = window.pageYOffset || document.documentElement.scrollTop;
            if (window.innerWidth <= 768) {
                if (st > lastScrollTop && st > 100) {
                    setVisible(false);
                } else {
                    setVisible(true);
                }
            } else {
                setVisible(false);
            }
            setLastScrollTop(st <= 0 ? 0 : st);
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);
        handleScroll(); // Initial check

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, [lastScrollTop]);

    return (
        <div 
            className="mobile-only-footer" 
            id="mobile-footer" 
            style={{ transform: visible ? 'translateY(0)' : 'translateY(120%)' }}
        >
            <ul className="nav-links">
                <li className="active">
                    <a href="#home" id="mnav-home">
                        <i className="fa-solid fa-house"></i>
                        <span>Home</span>
                    </a>
                </li>
                <li>
                    <a href="#features" id="mnav-features">
                        <i className="fa-solid fa-table-cells-large"></i>
                        <span>Features</span>
                    </a>
                </li>
                <li className="fab-container">
                    <button className="fab-btn" id="mnav-fab">
                        <i className="fa-solid fa-plus"></i>
                    </button>
                </li>
                <li>
                    <a href="#dashboard" id="mnav-profile">
                        <i className="fa-solid fa-user"></i>
                        <span>Profile</span>
                    </a>
                </li>
                <li>
                    <a href="#" id="mnav-settings">
                        <i className="fa-solid fa-gear"></i>
                        <span>Settings</span>
                    </a>
                </li>
            </ul>
        </div>
    );
};

export default MobileOnlyFooter;
